import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme, Typography } from "@material-ui/core";
import RestoreIcon from '@material-ui/icons/Restore';
import LocalGasStationIcon from '@material-ui/icons/LocalGasStation';
import { TooltipTop as CustomTooltip } from "../../../Common/CustomTooltips";
import styles from "./styles";
import t from "../../../../languages/pl";

const useStyles = makeStyles(theme => styles(theme, ({ })));

const Route = props => {
    const { time, amount } = props;
    const theme = useTheme();
    const classes = useStyles(theme);

    return (
        <React.Fragment>
            <div className={classes.location}>
                <CustomTooltip title={t.refuelDate}>
                    <RestoreIcon />
                </CustomTooltip>
                &nbsp;<Typography
                    variant="body2"
                >
                    {time}
                </Typography>
            </div>
            <div className={classes.location}>
                <CustomTooltip title={t.refuel}>
                    <LocalGasStationIcon />
                </CustomTooltip>&nbsp;
                <Typography
                    variant="body2"
                >
                    {t.refueled}&nbsp;{amount}&nbsp;l
                </Typography>
            </div>
        </React.Fragment>
    );
};

Route.propTypes = {
    time: PropTypes.string,
    amount: PropTypes.number,
};

export default Route;
